export default __webpack_public_path__ + "static/media/two_of_pentacles.7c7b7a9b.png";